import { createContext } from "react";

export type LoadingContextValue = {
  show: () => void;
  hide: () => void;
  isLoading: boolean;
};

export const LoadingContext = createContext<LoadingContextValue | undefined>(undefined);
